import React from 'react';
import PropTypes from 'prop-types';
import '../../styles/skeleton.css';

const SkeletonLoader = ({ 
  width = '100%', 
  height = '20px', 
  borderRadius = '4px',
  marginBottom = '0',
  variant = 'rectangular' 
}) => {
  const style = {
    width,
    height,
    borderRadius: variant === 'circular' ? '50%' : borderRadius,
    marginBottom
  };

  return <div className="skeleton" style={style} />;
};

SkeletonLoader.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  borderRadius: PropTypes.string,
  marginBottom: PropTypes.string,
  variant: PropTypes.oneOf(['rectangular', 'circular'])
};

// Preset skeleton patterns
export const SkeletonConversationItem = () => (
  <div className="skeleton-conversation-item">
    <div className="skeleton-icon-wrapper">
      <SkeletonLoader variant="circular" width="20px" height="20px" />
    </div>
    <div className="skeleton-content">
      <SkeletonLoader width="70%" height="14px" marginBottom="6px" />
      <SkeletonLoader width="40%" height="12px" />
    </div>
  </div>
);

export const SkeletonMessage = ({ isUser = false }) => (
  <div className={`skeleton-message ${isUser ? 'skeleton-message-user' : 'skeleton-message-ai'}`}>
    <SkeletonLoader 
      width={isUser ? '60%' : '80%'} 
      height="60px" 
      borderRadius="12px"
    />
  </div>
);

SkeletonMessage.propTypes = {
  isUser: PropTypes.bool
};

export const SkeletonTableRow = () => (
  <div className="skeleton-table-row">
    <SkeletonLoader width="30%" height="16px" />
    <SkeletonLoader width="15%" height="16px" />
    <SkeletonLoader width="20%" height="16px" />
    <SkeletonLoader width="20%" height="16px" />
    <SkeletonLoader width="15%" height="16px" />
  </div>
);

export default SkeletonLoader;